module.exports = __webpack_public_path__ + "media/images/news/post-noimg-fce492a2e0b3d36c18299a16613d7ab2.jpeg";